export enum StorageType {
  DeviceId = 'device-id',
  DeviceToken = 'device-token',
  AuthToken = 'auth-token',
  NotificationToken = 'notification-token',
  SendTransferNotifications = 'send-transer-notitifications',
  SendPromoNotifications = 'send-promo-notifications',
  FingerprintPinFails = 'fingerprint-pin-fails',
  FingerprintToken = 'fingerprint-token',
  FingerprintDeviceToken = 'fingerprint-device-token',
  FingerprintPin = 'fingerprint-pin',
  LastBiometricCustomerId = 'last-biometric-customer-id',
  RecipientImage = 'recipient-image',
  AppVersionInStorage = 'app-version-in-storage',
  LastLogin = 'last-login',
  LastLoginCountry = 'last-login-country',
  Language = 'language',
  VirtualUuid = 'VirtualUuid',
  RefreshToken = 'refresh-token',
  UserCountry = 'UserCountry',
  GuestOrder = 'Guestorder',
  SendFromRecipient = 'SendFromRecipient',
  DisabledRegistration = 'DisabledRegistration',
  EnableFirstFingerPrint = 'EnableFirstFingerPrint',
  SkipScreenLockCheck = 'SkipScreenLockCheck',
  PendingOrder = 'PendingOrder',
  StoredOrder = 'StoredOrder',
  CachedPreConfrimOrder = 'CachedPreConfrimOrder',
  MfaDeviceToken = 'mfa-device-token',
  DeviceTrustToken = 'device-trust-token',
  RiaDeviceToken = "RiaDeviceToken",
  ConsentIDFA = "ConsentIDFA",
  ConsentIDFAPermission = "ConsentIDFAPermission",
  ConsentIDFARetried = "ConsentIDFARetried",
  ConsentIDFAReasked = "ConsentIDFAReasked",
  LastDeviceLanguage = 'LastDeviceLanguage',
  ShowActivateWalletPopup = 'ShowActivateWalletPopup',
  ShowNonFPXPopup = 'ShowNonFPXPopup',
  SyncContactsAutomatically ='SyncContactsAutomatically',
  PendingEmailChange = 'PendingEmailChange',
  IsExternalTester = 'IsExternalTester',
  ContactsPermission = 'ContactsPermission',
  IsContactsAccessGiven ='IsContactsAccessGiven',
  AccertifyTransactionID = 'AccertifyTransactionID',
  AccertifyTransactionIDFetchedTime = 'AccertifyTransactionIDFetchedTime',
  DefaultCountryTo = 'DefaultCountryTo',
  TokenReference = 'TokenReference',
  RecentData = 'RecentData',
  WidgetOpenedTime = 'WidgetOpenedTime',
  ReminderBiometric = 'Reminder-Biometric',
  LocationAccess = 'LocationAccess',
  NotificationAccess = 'NotificationAccess',
  SegmentUserId = 'SegmentUserId',
  PendingRedirectTransactionId = 'PendingRedirectTransactionId',
  AgentReferralToken = 'AgentReferralToken',
  AgentReferralData = 'AgentReferralData',
  ShownDebitCardPayoutInfo = 'ShownDebitCardPayoutInfo',
  userSendingCountry = 'userSendingCountry',
  ExternalAuthSecurityCode = 'ExternalAuthSecurityCode',
  PrepaidCardBannerDismissed = 'PrepaidCardBannerDismissed',
  PendingOrderExpiredDismissed = 'PendingOrderExpiredDismissed',
  WalletVerificationStatus = 'WalletVerificationStatus',
  SessionEnv = 'SessionEnv',
  SendAgainWithCalculatorHintCount = 'SendAgainWithCalculatorHintCount',
  LastLoginFirstName = 'LastLoginFirstName',
  HiddenMenuFeatures = 'HiddenMenuFeatures',
  HiddenMenuLastAppliedFeatures = 'HiddenMenuLastAppliedFeatures',
  GoogleLiteAutoPromoCode = 'GoogleLiteAutoPromoCode',
  WalletQrCodeString = 'WalletQrCodeString',
  WalletDuitnowStaticQrImage = 'WalletDuitnowStaticQrImage',
  WelcomePendingCountryFrom = 'WelcomePendingCountryFrom',
  WelcomePendingCountryTo = 'WelcomePendingCountryTo',
  FeatureFlagOverrides = 'FeatureFlagOverrides',
  Rmt5FlagMode = 'Rmt5FlagMode',
  ForeignIpTestOverrides = 'ForeignIpTestOverrides',
  DingConsentPrefix = 'ding-consent-',
  MobileTopUpBannerDismissedPrefix = 'rmt5-home-mobile-top-up-banner-dismissed-',
  SNWalletHasTransactions = 'SNWalletHasTransactions',
  WalletCachedBalance = 'WalletCachedBalance'
}



// WEBPACK FOOTER //
// ./src/model/types/storage-type.ts